var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"is-unselectable",class:_vm.classes},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked,"value":_vm.checkValue},on:{"input":_vm.onChange}}),(_vm.label)?_c('span',{class:_vm.cssClassLabel},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }